import { FormProvider as Form } from 'react-hook-form';

export default function FormProvider({ children, onSubmit, methods, style }) {
  return (
    <Form {...methods} >
      <form style={{display: 'flex', flexDirection: 'column', ...style}} onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
